import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getSavedMix } from 'stash/components/invest-an-idea/savedMix';
import { HOME_ROUTE } from 'stash/constants/routes';
import { UUID_COOKIE_NAME } from 'stash/constants/session';
import { selectIsAccountlessAppEntryEnabled } from 'stash/selectors';
import { getCookie } from 'stash/utils/cookies';
import localStorage from 'stash/utils/localStorage';

const INVEST_AN_IDEA_PATH = '/invest-an-idea';

export function useSavedMixPrimer() {
	const history = useHistory();
	const userId = getCookie(UUID_COOKIE_NAME);
	const activationHome = useSelector(selectIsAccountlessAppEntryEnabled);
	const { mixName, prompt } = getSavedMix();
	const storageKey = `saved-mix-primer-completed:${userId}`;
	const handoffKey = `${mixName}\u0000${prompt}`;
	const [completed, setCompleted] = useState(
		() => localStorage.getItem(storageKey) === handoffKey
	);

	const complete = (to: Parameters<typeof history.push>[0]) => {
		localStorage.setItem(storageKey, handoffKey);
		setCompleted(true);
		history.push(to);
	};

	return {
		visible: Boolean(userId && mixName && prompt) && !completed && !activationHome,
		mixName,
		onInvest: () =>
			complete({
				pathname: INVEST_AN_IDEA_PATH,
				state: { origin: 'home', rerunSavedMix: true },
			}),
		onMakeNewMix: () => complete(INVEST_AN_IDEA_PATH),
		onBack: () => complete(HOME_ROUTE),
	};
}
